<template>
  <div>
    <el-card>
      <edit-form
        :disabled="isDisableEditForm"
        ref="editForm"
        :formData="formData"
      />
    </el-card>
    <el-card class="mt-2">
      <sample-goods
        ref="goodsForm"
        :disabled="isDisableEditForm"
        :tableData="formData.dataList"
      >
      </sample-goods>
      <div
        class="d-flex justify-content-end mt-2 mb-2"
        v-if="!isDisableEditForm"
      >
        <el-button type="primary" size="small" @click="save()">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SampleGoods from '../components/edit-form/sample-goods.vue'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  name: 'samplemanage-billStockBatchReturn-detail',
  components: {
    EditForm,
    SampleGoods,
  },
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      formData: {},
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        add:
          this.$l('form_label_add_sample_loan_order_information') ||
          '添加样品外借单信息',
        edit:
          this.$l('form_label_edit_sample_loan_order_information') ||
          '编辑样品外借单信息',
        detail:
          this.$l('form_label_details_sample_loan_order_information') ||
          '样品外借单信息详情',
      }
      return types[this.pageType]
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    this.code = this.params.code
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.code) return
      this.$api
        .sampleStockBatchReturnDetailApi({
          stockBatchReturnCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      // 获取主信息
      const getFormData = await this.$refs.editForm.getFormData()
      if (!getFormData) {
        return
      }
      // 获取样品信息
      const dataList = await this.$refs.goodsForm.getGoodsData()
      if (dataList.length == 0) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.form_label_please_select_sample_information') ||
            '请选择样品信息',
          type: 'warning',
        })
        return
      }
      // 合成订单提交参数
      let params = {
        ...getFormData,
        dataList,
      }
      this.loadingOpen()
      this.$api
        .sampleStockBatchReturnSaveApi(params)
        .then(() => {
          this.loadingClose()
          this.saveOkQuestion()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
